/**
 * Utility functions for handling page visibility
 */

/**
 * Sets up a visibility change listener and returns the current visibility state
 * @param {Function} callback - Function to call when visibility changes
 * @returns {Object} - Object with isVisible property and cleanup function
 */
export const setupVisibilityDetection = (callback) => {
  // Initial visibility state
  let isVisible = document.visibilityState === 'visible';
  
  // Function to handle visibility change
  const handleVisibilityChange = () => {
    const newVisibility = document.visibilityState === 'visible';
    isVisible = newVisibility;
    
    // Call the callback with the new visibility state
    if (callback && typeof callback === 'function') {
      callback(newVisibility);
    }
    
    console.log(`Page visibility changed: ${newVisibility ? 'visible' : 'hidden'}`);
  };
  
  // Add visibility change listener
  document.addEventListener('visibilitychange', handleVisibilityChange);
  
  // Return current visibility and cleanup function
  return {
    isVisible,
    cleanup: () => document.removeEventListener('visibilitychange', handleVisibilityChange)
  };
}; 